module.exports = __webpack_public_path__ + "static/media/parent-dashboard-children.cb0d9d5f.svg";